export var Shadows;
(function (Shadows) {
    Shadows["sm"] = "0px 1px 3px rgba(55, 66, 77, 0.15)";
    Shadows["base"] = "0px 4px 6px rgba(27, 33, 38, 0.2)";
    Shadows["md"] = "0px 10px 15px rgba(27, 33, 38, 0.2)";
    Shadows["lg"] = "0px 20px 25px rgba(27, 33, 38, 0.2)";
})(Shadows || (Shadows = {}));
//# sourceMappingURL=shadows.js.map